import Backend from "../../../Backend";

export const getProducts = async () => {
  try {
    const response = await Backend.post("api/products/list");
    return response;
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};

export const getProduct = (id) =>
  Backend.get(`api/products/${id}`);

export const searchProductsByName = async (name) => {
  try {
    const response = await Backend.post("api/products/search", { name });
    return response;
  } catch (error) {
    console.error("Error searching products by name:", error);
    throw error;
  }
};

export const createProduct = (product) =>
  Backend.post("api/products", product);

export const updateProduct = (id, product) =>
  Backend.put(`api/products/${id}`, product);

export const deleteProduct = (id) =>
  Backend.delete(`api/products/${id}`);

export const getLowStockProducts = async () => {
  try {
    const response = await Backend.get("api/products/low-stock");
    return response;
  } catch (error) {
    console.error("Error fetching low stock products:", error);
    return [];
  }
};

export const updateInventory = (id, quantity) =>
  Backend.put(`api/products/${id}/inventory`, { quantity });
